import React from 'react';
import { Form } from 'antd';
import { PropTypes } from 'prop-types';
import {
	DisplayFlexAlign,
	RadioButtonWrapper,
	LabelWrapperDelivery,
	MainWrapper,
	MailContentWrapper,
	SpanWrap,
	MailContentWrapperfirst,
	DeliveryMarginBottom,
	Underlinelink,
	TextWrap,
} from '../styles';
import ViewAdditionalInfo from './ViewAdditionalInfo';
import { ContentProvider, Types } from '../../../../../CommonComponents/ContentMessages';
import { RadioButton } from '../../../../../CommonComponents/commonStyles';

const radioButtonValue = (props) => {
	if (props.state.advisorType === 'Primary') {
		if (props.state.primaryAdvisor.deliveryMethod == null) {
			return 'E-Delivery';
		} else {
			return props.state.primaryAdvisor.deliveryMethod;
		}
	} else {
		if (props.state.secondaryAdvisor.deliveryMethod) {
			return props.state.secondaryAdvisor.deliveryMethod;
		} else {
			return 'E-Delivery';
		}
	}
};

function DeliveryMethod(props) {
	return (
		<ContentProvider types={[Types.GET_MODAL_CONTENT]} pages={['Delivery Method']}>
			<MainWrapper>
				{props.state.showInfo ? <ViewAdditionalInfo handleOkay={(e) => props.handleOkay(e)} /> : null}
				<Form.Item
					label={
						<DeliveryMarginBottom>
							<LabelWrapperDelivery>Preferred Delivery Method</LabelWrapperDelivery>
						</DeliveryMarginBottom>
					}
				>
					<RadioButtonWrapper
						onChange={(e) => props.handleRadioChange(e, 'deliveryMethod', props.state.advisorType)}
						value={radioButtonValue(props)}
					>
						<MailContentWrapper>
							<DisplayFlexAlign>
								<RadioButton
									defaultChecked={true}
									value="E-Delivery"
									id={props.id && 'rdElectronicDelivery' + props.id}
								>
									<TextWrap>Electronic delivery (suggested)</TextWrap>
								</RadioButton>
								<Underlinelink
									onClick={(e) => props.handleViewInfo(e)}
									id={props.id && 'anrVisualAdditionalInfo' + props.id}
								>
									View additional information
								</Underlinelink>
							</DisplayFlexAlign>
						</MailContentWrapper>
						<MailContentWrapperfirst>
							<RadioButton value="Paper" id={props.id && 'rdPaper' + props.id}>
								<TextWrap>Paper delivery (U.S. mail)</TextWrap>
							</RadioButton>
						</MailContentWrapperfirst>
						<MailContentWrapperfirst>
							<RadioButton
								value="Paper Delivery With Electronic Notification"
								id={props.id && 'rdUsMail' + props.id}
							>
								<SpanWrap>U.S. mail with email notification</SpanWrap>
							</RadioButton>
						</MailContentWrapperfirst>
					</RadioButtonWrapper>
				</Form.Item>
			</MainWrapper>
		</ContentProvider>
	);
}

DeliveryMethod.propTypes = {
	handleOkay: PropTypes.func,
	handleRadioChange: PropTypes.func,
	handleViewInfo: PropTypes.func,
	id: PropTypes.string,
	state: PropTypes.any,
};

export default DeliveryMethod;